<template>
    <div class="position">
        <div>
            <h3 class="popup-tilte">Felmondási idő lejárt.</h3>
            <div class="fs-desc popup-content-width">
                <div>Felmondási idő lejárt. ({{ getCalculation.old_start_of_risk }})</div>
                <div>
                    <a href="/" target="_self" style="margin-left: 0;" class="navBtn-next btn btn-blue">Vissza a főoldalra!</a>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapActions, mapGetters,} from 'vuex';

export default {
    computed: {
        ...mapGetters(['getCalculation']),
    },
};
</script>
